import axios from "axios";

const endpoint = process.env.REACT_APP_API_URL;

export const FETCH_COMPANIES_BEGIN = "FETCH_COMPANIES_BEGIN";
export const FETCH_COMPANIES_SUCCESS = "FETCH_COMPANIES_SUCCESS";
export const FETCH_COMPANIES_FAILURE = "FETCH_COMPANIES_FAILURE";

export const DELETE_COMPANY_BEGIN = "DELETE_COMPANY_BEGIN";
export const DELETE_COMPANY_SUCCESS = "DELETE_COMPANY_SUCCESS";
export const DELETE_COMPANY_FAILURE = "DELETE_COMPANY_FAILURE";

export const fetchCompaniesBegin = () => ({
  type: FETCH_COMPANIES_BEGIN,
});

export const fetchCompaniesSuccess = (companies) => ({
  type: FETCH_COMPANIES_SUCCESS,
  payload: companies,
});

export const fetchCompaniesFailure = (error) => ({
  type: FETCH_COMPANIES_FAILURE,
  payload: { error },
});

export const deleteCompanyBegin = () => ({
  type: DELETE_COMPANY_BEGIN,
});

export const deleteCompanySuccess = (id) => ({
  type: DELETE_COMPANY_SUCCESS,
  id,
});

export const deleteCompanyFailure = (error) => ({
  type: DELETE_COMPANY_FAILURE,
  payload: { error },
});

export async function getCompanies() {
  return async (dispatch) => {
    dispatch(fetchCompaniesBegin());
    try {
      const { data } = await axios.get(`${endpoint}/companies`);
      dispatch(fetchCompaniesSuccess(data));
    } catch (err) {
      dispatch(fetchCompaniesFailure(err));
    }
  };
}

export const deleteCompany = async (id) => {
  return async (dispatch) => {
    dispatch(deleteCompanyBegin());
    try {
      await axios.delete(`${endpoint}/companies/${id}`);
      dispatch(deleteCompanySuccess(id));
    } catch (err) {
      dispatch(deleteCompanyFailure(err));
    }
  };
};
